import { Collapse, IconButton, useDisclosure } from '@chakra-ui/react';

import { useTranslation } from 'react-i18next';

import Link from 'next/link';

import {
  Box,
  Container,
  Flex,
  Link as JaimyLink,
  LogoLight,
  LogoSmall,
} from '@brand/components';
import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';

import pages from 'constants/pages';

import { useReduxSelector } from 'hooks/redux/useReduxSelector';

import DesktopNav from 'components/molecules/nav/Desktop';
import MobileNav from 'components/molecules/nav/Mobile';

import authSelectors from 'store/slices/auth/selectors';

const Navbar = () => {
  const { isOpen, onToggle } = useDisclosure();
  const { t } = useTranslation('common');
  const accessToken = useReduxSelector(authSelectors.accessToken);

  return (
    <Box backgroundColor="secondary" color="white" mb={[2, 4, 8]} padding={4}>
      <Container>
        <Flex
          align="center"
          display={['flex', null, 'none']}
          justifyContent="space-between"
          width="100%"
        >
          <IconButton
            aria-label="Toggle Navigation"
            icon={
              isOpen ? (
                <CloseIcon h={6} m={2} w={6} />
              ) : (
                <HamburgerIcon h={6} m={2} w={6} />
              )
            }
            onClick={onToggle}
          />

          <JaimyLink
            aria-describedby="Home Page Link"
            aria-label="Home Page"
            href="/"
          >
            <LogoSmall height={8} width="auto" />
          </JaimyLink>

          {!accessToken && (
            <Link href={pages.auth} passHref>
              <JaimyLink height="fit-content">{t('generic.sign_in')}</JaimyLink>
            </Link>
          )}
        </Flex>

        {/* Desktop navigation */}
        <Flex
          alignItems="center"
          display={['none', null, 'flex']}
          justifyContent="space-between"
          width="100%"
        >
          <Link href={pages.home} passHref>
            <LogoLight cursor="pointer" height={10} width="auto" />
          </Link>
          <DesktopNav />
        </Flex>
        {/* Mobile Navigation */}
        <Collapse animateOpacity in={isOpen}>
          <MobileNav />
        </Collapse>
      </Container>
    </Box>
  );
};

export default Navbar;
